import styled from '@emotion/styled';
import { Color } from '../../../../../styles/Color';
import { Css, Responsive } from '../../../../../ui';
import { StyledRouterLink } from '../../../../parking-availability/ui/ParkingsLotsTable.styles';

export const StyledRouterLinkContainer = styled(StyledRouterLink)`
	padding: ${Css.pxToRem(12)};
	display: flex;
	align-items: center;
	gap: ${Css.pxToRem(12)};
	text-decoration: none;
	background: ${Color.PrimaryWhite};
	border-radius: ${Css.pxToRem(8)};
`;

export const Information = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: ${Css.pxToRem(4)};
`;

export const Title = styled.p`
	color: ${Color.PrimaryBlue};
	font-weight: 700;
	line-height: ${Css.pxToRem(24)};
	margin: 0;

	& em {
		font-style: normal;
		font-weight: 700;
	}
`;

export const Separator = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${Color.Neutral10};
`;

export const Snippet = styled.p`
	color: ${Color.Neutral};
	margin: 0;
	line-height: 1.5;
	width: 100%;
	overflow: hidden;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		width: 95%;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		width: 100%;
	}

	& em {
		font-style: normal;
		font-weight: 700;
		color: ${Color.PrimaryBlue};
	}
`;

export const IconWrap = styled.div`
	display: inline-flex;
	align-items: center;
	color: ${Color.Neutral60};
`;
